module.exports = __webpack_public_path__ + "static/media/landing_bottom_background.1f86eb6b.png";